// extracted by mini-css-extract-plugin
module.exports = {"videoBox":"videoBox-module--video-box--ufqto","bg":"videoBox-module--bg--3aerp"};